module.exports = __webpack_public_path__ + "static/regulatorbefore-e26a8ea350078a3360f85633b360e032.jpg";